{
    "Title": "Gestisci code",
    "ManageQueuesDescriptionTitle": "Descrizione",
    "ManageQueuesCQConfigurationsTitle": "Configurazioni CQ",
    "ManageQueuesResourceAccountsTitle": "Conti delle risorse",
    "ManageQueuesMonitoringStatusTitle": "Stato di monitoraggio",
    "ManageQueueFiltersTitle": "Filtri",
    "ManageQueueCallMonitoringHistoric": "Storico",
    "ManageQueueCallMonitoringRealTime": "In tempo reale",
    "ManageQueueCallMonitoringRealTimeForced": "In tempo reale (forzato)",
    "ManageQueueCallMonitoringUnknown": "Sconosciuto",
    "ManageQueueCallCQConfigurationCompatible": "Compatibile",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatibile",
    "ManageQueuesQueueFilterAll": "Tutte le code",
    "ManageQueuesFilterCompatible": "Code compatibili",
    "ManageQueuesFilterIncompatible": "Code incompatibili",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confermare",
    "ManageQueue_DisableEnableRealtime_Cancel": "Cancellare",
    "ManageQueue_MonitorAllMessage": "Vuoi davvero abilitare il monitoraggio in tempo reale per tutte le code?",
    "ManageQueue_UnmonitorAllMessage": "Vuoi davvero disattivare il monitoraggio in tempo reale per tutte le code?",
    "ManageQueue_Loading_Monitoring_All": "Abilitazione del monitoraggio in tempo reale per tutte le code",
    "ManageQueue_Loading_Unmonitoring_All": "Disabilitare il monitoraggio in tempo reale per tutte le code",
    "ManageQueue_Pending_Queue_Disabling": "Disattivazione del monitoraggio...",
    "ManageQueue_Pending_Queue_Enabling": "Abilitazione del monitoraggio...",
    "ManageQueue_Disable_RT_Popper": "Disabilita il monitoraggio in tempo reale su tutte le code",
    "ManageQueue_Enable_RT_Popper": "Abilita il monitoraggio in tempo reale su tutte le code",
    "ManageQueues_Not_Found_Error": "Non sono state trovate code corrispondenti a quella ricerca",
    "NAME": "ManageQueues",
    "ManageQueues_Linkage_Title": "Account di risorse collegati \/ App vocali",
    "ManageQueues_Linkage_Help": "Fare clic su Aiuto per scoprire come ricollegare gli account delle risorse",
    "ManageQueues_Linkage_Types_CallQueue": "L'account di risorse '**{}**' viene utilizzato per la gestione delle eccezioni '**{}**' sulla coda di chiamata '**{}**'.",
    "ManageQueues_Linkage_Types_AutoAttendant": "L'account di risorse '**{}**' viene utilizzato per l'opzione '**{}**' di '**{}**' sul risponditore automatico '**{}**'.",
    "ManageQueues_Linkage_Types_Policy": "L'account di risorse '**{}**' è utilizzato all'interno della policy '**{}**' di tipo '**{}**'.",
    "ManageQueues_Linkage_CallQueue_Exceptions_overflow": "Traboccamento",
    "ManageQueues_Linkage_CallQueue_Exceptions_timeout": "Tempo scaduto",
    "ManageQueues_Linkage_CallQueue_Exceptions_noagent": "Nessun agente",
    "ManageQueues_Linkage_CallQueue_Exceptions_obo": "Per conto di",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_businesshours": "Orari di apertura",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_afterhours": "Dopo l'orario di lavoro",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_holiday": "Vacanza",
    "ManageQueues_Linkage_Policy_Types_teamssharedcallingroutingpolicy": "Criterio di instradamento delle chiamate condivise",
    "ManageQueues_Linkage_Policy_Types_teamsunassignednumbertreatment ": "Trattamento dei numeri non assegnati",
    "ManageQueues_Linkage_Policy_Types_callinglineidentity": "Identità della linea chiamante",
    "ManageQueues_Linkage_Options_automatic": "Reindirizzare",
    "ManageQueues_Linkage_Options_pound": "Libbra",
    "ManageQueues_Linkage_Options_star": "Stella",
    "ManageQueues_Linkage_NoInfo": "Nessun riferimento all'account di risorse per questa coda.",
    "ManageQueues_Incompatibility_Popup_Title": "Impostazioni incompatibili",
    "ManageQueues_ExchangePermission_Error": "Autorizzazione di amministratore utente\/Exchange non trovata per l'utente TelSys Auth. Impossibile creare segreterie vocali condivise."
}